/** Namespace `smartai` — Admin-Seite der KI-Rezeption (Wissensbasis, Sichtbarkeit). */
export const smartai = {
  de: {
    smartai: {
      title: 'SmartAI',
      description: 'Wissensbasis und Sichtbarkeit des Website-Panels verwalten. Aus der Wissensbasis beantwortet die KI Besucherfragen — sie ist die einzige Quelle.',
      // Kennzahlen
      statsTitle: 'Nutzung',
      statsToday: 'Heute: {{calls}} / {{limit}} KI-Anfragen',
      statsCallbacks: 'Rückrufe: {{count}}',
      statsDocuments: 'Rezept/Dokumente: {{count}}',
      statsQuestions: 'Offene Fragen: {{count}}',
      // Sichtbarkeit
      visibilityTitle: 'Sichtbarkeit des Panels',
      visibilityPreview: 'Preview (nur mit ?smartai=preview sichtbar)',
      visibilityPublic: 'Öffentlich (für alle Besucher sichtbar)',
      visibilityHint: 'Master-Schalter ist das Feature „SmartAI" im Features-Tab. Preview eignet sich für Tests auf der Live-Seite, unsichtbar für Besucher.',
      visibilitySaved: 'Sichtbarkeit gespeichert.',
      // Panel-Variante
      layoutTitle: 'Panel-Variante',
      layoutClassic: 'Klassisch (Buchung öffnet den Wizard)',
      layoutV2: 'Neu (Buchung und Terminverwaltung im Panel)',
      layoutHint: 'Umschalten wirkt sofort, ohne Deploy. Bei Problemen mit der neuen Variante genügt der Wechsel zurück auf Klassisch.',
      layoutSaved: 'Panel-Variante gespeichert.',
      // KI-Anbieter
      llmTitle: 'KI-Anbieter',
      llmOff: 'KI aus (nur strukturierte Anliegen)',
      llmOn: 'KI an (Fireworks — Drittland USA)',
      llmModel: 'Modell',
      llmModelActive: 'Aktiv: {{model}}',
      llmModelDefault: 'Standard einsetzen',
      llmEffort: 'Denkaufwand des Modells',
      llmEffort_default: 'Standard des Anbieters',
      llmEffort_none: 'Aus — antwortet sofort (empfohlen)',
      llmEffort_low: 'Niedrig',
      llmEffort_medium: 'Mittel',
      llmEffort_high: 'Hoch',
      llmEffortHint: 'Reasoning-Modelle denken vor der Antwort intern nach. Das kostet Tokens und Sekunden; für Besucherfragen aus der Wissensbasis bringt es nichts. „Aus" ist die schnellste und günstigste Wahl. Kennt ein Anbieter die Einstellung nicht, wird sie ignoriert.',
      llmKey: 'API-Schlüssel',
      llmKeyEmpty: 'kein Schlüssel hinterlegt',
      llmKeyHint: 'Wird verschlüsselt gespeichert und nie wieder angezeigt. Feld leer lassen heißt: unverändert.',
      llmKeyFromEnv: 'Der Schlüssel kommt derzeit aus der Server-Konfiguration. Ein hier eingetragener Schlüssel hat Vorrang.',
      llmKeyClear: 'Gespeicherten Schlüssel löschen',
      llmSave: 'Speichern',
      llmSaved: 'KI-Einstellungen gespeichert.',
      llmTest: 'Verbindung testen',
      llmTestOk: 'Verbindung steht ({{ms}} ms)',
      llmTestFailed: 'Verbindung fehlgeschlagen',
      llmTestReply: 'Antwort: {{reply}}',
      llmTestReasoning: '{{tokens}} Tokens gingen ins interne Nachdenken — mit Denkaufwand „aus" wird es schneller und günstiger.',
      llmTestUnreachable: 'Server nicht erreichbar.',
      llmHint: 'Der Test schickt eine feste Testnachricht an den Anbieter — nie Besuchertext. Er funktioniert auch bei ausgeschalteter KI, damit Schlüssel und Modell vorab geprüft werden können.',
      // Übernahme aus dem Posteingang
      captureAction: 'In die Wissensbasis',
      captureTitle: 'Frage in die Wissensbasis übernehmen',
      captureHint: 'Die Frage wird zum Titel, Ihre Antwort zum Inhalt. Beim nächsten Mal beantwortet die digitale Rezeption sie selbst.',
      captureAnswer: 'Antwort',
      captureAnswerPlaceholder: 'Kurz und konkret antworten — so, wie es ein Besucher gefragt hat.',
      captureSave: 'Eintrag anlegen',
      captureSaved: 'Eintrag in der Wissensbasis angelegt.',
      // Wissensbasis
      knowledgeTitle: 'Wissensbasis',
      knowledgeHint: 'Einträge nur auf Deutsch pflegen — die KI antwortet automatisch in der Sprache des Besuchers. Der gesamte Inhalt wird bei jeder Frage mitgeschickt.',
      estimatedTokens: 'Umfang: ~{{count}} Tokens pro Anfrage',
      addEntry: 'Eintrag hinzufügen',
      editEntry: 'Eintrag bearbeiten',
      fieldCategory: 'Kategorie',
      fieldTitle: 'Titel',
      fieldContent: 'Inhalt (Deutsch)',
      fieldEnabled: 'Aktiv',
      fieldSortOrder: 'Sortierung',
      save: 'Speichern',
      cancel: 'Abbrechen',
      delete: 'Löschen',
      confirmDelete: 'Diesen Eintrag wirklich löschen?',
      saved: 'Eintrag gespeichert.',
      deleted: 'Eintrag gelöscht.',
      errorLoad: 'SmartAI-Daten konnten nicht geladen werden.',
      errorSave: 'Speichern fehlgeschlagen.',
      empty: 'Noch keine Einträge. Über „Eintrag hinzufügen" starten oder das Seed-Script ausführen.',
      disabledBadge: 'inaktiv',
      categories: {
        hours: 'Öffnungszeiten',
        directions: 'Anfahrt',
        team: 'Team & Kontakt',
        services: 'Leistungen',
        pricing: 'Preise',
        insurance: 'Versicherung',
        faq: 'FAQ',
        policy: 'Praxis-Regeln',
        custom: 'Sonstiges',
      },
    },
  },
  es: {
    smartai: {
      title: 'SmartAI',
      description: 'Gestionar la base de conocimiento y la visibilidad del panel de la web. La IA responde a los visitantes únicamente a partir de esta base.',
      statsTitle: 'Uso',
      statsToday: 'Hoy: {{calls}} / {{limit}} consultas IA',
      statsCallbacks: 'Llamadas: {{count}}',
      statsDocuments: 'Receta/documentos: {{count}}',
      statsQuestions: 'Preguntas abiertas: {{count}}',
      visibilityTitle: 'Visibilidad del panel',
      visibilityPreview: 'Preview (visible solo con ?smartai=preview)',
      visibilityPublic: 'Público (visible para todos los visitantes)',
      visibilityHint: 'El interruptor principal es el feature «SmartAI» en la pestaña Features. Preview sirve para probar en la web en vivo sin que lo vean los visitantes.',
      visibilitySaved: 'Visibilidad guardada.',
      // Variante del panel
      layoutTitle: 'Variante del panel',
      layoutClassic: 'Clásica (la reserva abre el asistente)',
      layoutV2: 'Nueva (reservar y gestionar la cita dentro del panel)',
      layoutHint: 'El cambio surte efecto de inmediato, sin despliegue. Si la variante nueva da problemas, basta con volver a la clásica.',
      layoutSaved: 'Variante del panel guardada.',
      // Proveedor de IA
      llmTitle: 'Proveedor de IA',
      llmOff: 'IA desactivada (solo solicitudes estructuradas)',
      llmOn: 'IA activada (Fireworks — EE. UU.)',
      llmModel: 'Modelo',
      llmModelActive: 'Activo: {{model}}',
      llmModelDefault: 'Usar el estándar',
      llmEffort: 'Esfuerzo de razonamiento',
      llmEffort_default: 'Estándar del proveedor',
      llmEffort_none: 'Desactivado — responde de inmediato (recomendado)',
      llmEffort_low: 'Bajo',
      llmEffort_medium: 'Medio',
      llmEffort_high: 'Alto',
      llmEffortHint: 'Los modelos de razonamiento piensan internamente antes de responder. Eso cuesta tokens y segundos, y no aporta nada para preguntas que se responden desde la base de conocimiento. «Desactivado» es la opción más rápida y económica. Si un proveedor no conoce el ajuste, se ignora.',
      llmKey: 'Clave de API',
      llmKeyEmpty: 'sin clave guardada',
      llmKeyHint: 'Se guarda en el servidor y no se vuelve a mostrar. Dejar el campo vacío significa: sin cambios.',
      llmKeyFromEnv: 'La clave viene de la configuración del servidor. Una clave introducida aquí tiene prioridad.',
      llmKeyClear: 'Borrar la clave guardada',
      llmSave: 'Guardar',
      llmSaved: 'Ajustes de IA guardados.',
      llmTest: 'Probar conexión',
      llmTestOk: 'Conexión correcta ({{ms}} ms)',
      llmTestFailed: 'Fallo de conexión',
      llmTestReply: 'Respuesta: {{reply}}',
      llmTestReasoning: '{{tokens}} tokens se usaron en el razonamiento interno — con el esfuerzo «desactivado» será más rápido y económico.',
      llmTestUnreachable: 'Servidor no accesible.',
      llmHint: 'La prueba envía un mensaje fijo al proveedor — nunca texto de visitantes. Funciona también con la IA desactivada, para comprobar clave y modelo de antemano.',
      // Traspaso desde la bandeja de entrada
      captureAction: 'A la base de conocimiento',
      captureTitle: 'Pasar la pregunta a la base de conocimiento',
      captureHint: 'La pregunta se convierte en el título y su respuesta en el contenido. La próxima vez la recepción digital responderá sola.',
      captureAnswer: 'Respuesta',
      captureAnswerPlaceholder: 'Responda de forma breve y concreta, tal como lo preguntaría un visitante.',
      captureSave: 'Crear entrada',
      captureSaved: 'Entrada creada en la base de conocimiento.',
      knowledgeTitle: 'Base de conocimiento',
      knowledgeHint: 'Mantener las entradas solo en alemán — la IA responde automáticamente en el idioma del visitante. Todo el contenido se envía con cada pregunta.',
      estimatedTokens: 'Volumen: ~{{count}} tokens por consulta',
      addEntry: 'Añadir entrada',
      editEntry: 'Editar entrada',
      fieldCategory: 'Categoría',
      fieldTitle: 'Título',
      fieldContent: 'Contenido (alemán)',
      fieldEnabled: 'Activa',
      fieldSortOrder: 'Orden',
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      confirmDelete: '¿Eliminar esta entrada?',
      saved: 'Entrada guardada.',
      deleted: 'Entrada eliminada.',
      errorLoad: 'No se pudieron cargar los datos de SmartAI.',
      errorSave: 'No se pudo guardar.',
      empty: 'Aún no hay entradas. Empiece con «Añadir entrada» o ejecute el script de seed.',
      disabledBadge: 'inactiva',
      categories: {
        hours: 'Horario',
        directions: 'Cómo llegar',
        team: 'Equipo y contacto',
        services: 'Tratamientos',
        pricing: 'Precios',
        insurance: 'Seguro',
        faq: 'FAQ',
        policy: 'Normas de la clínica',
        custom: 'Otros',
      },
    },
  },
};
